import { createReducer } from 'Helpers/redux'
import { uniqBy } from 'lodash'

import {
  GET_REJECT_REASONS,
  GET_ALL_TRACKS,
  GET_AWAITING_TRACKS,
  GET_REVIEWED_TRACKS,
  GET_MISSED_TRACKS,
  GET_CANCELLED_TRACKS,
  SEND_REVIEW,
  GET_WORDS_BLACKLIST,
  GET_CURATOR_STATS,
  SKIP_REVIEW,
  GET_SELECTED_CURATOR_STATS,
  GET_REVIEW_DETAILS,
} from '../actions/reviewsActions'

const initialState = {
  rejectReasons: [],
  rewardPerReview: 0,
  reviewDetails: {},
  allTracks: [],
  awaitingTracks: [],
  reviewedTracks: [],
  missedTracks: [],
  cancelledTracks: [],
  totalAllTracks: 0,
  totalAwaitingTracks: 0,
  totalReviewedTracks: 0,
  totalMissedTracks: 0,
  totalCancelledTracks: 0,
  wordsBlacklist: [],
  curatorStats: {},
  selectedCuratorStats: {},
  loading: true,
}

const handlers = {
  [GET_REJECT_REASONS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    rejectReasons: payload,
  }),
  [GET_AWAITING_TRACKS.REQUEST]: prevState => ({
    ...prevState,
    loading: prevState.awaitingTracks.length === 0,
  }),
  [GET_ALL_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    allTracks: payload.reviews ? payload.reviews : [],
    totalAllTracks: payload.total ? payload.total : 0,
  }),
  [GET_AWAITING_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    awaitingTracks: payload.reviews
      ? uniqBy([...prevState.awaitingTracks, ...payload.reviews], 'id')
      : [],
    totalAwaitingTracks: payload.total ? payload.total : 0,
    loading: false,
  }),
  [GET_REVIEWED_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    reviewedTracks: payload.reviews
      ? uniqBy([...prevState.reviewedTracks, ...payload.reviews], 'id')
      : [],
    totalReviewedTracks: payload.total ? payload.total : 0,
  }),
  [GET_MISSED_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    missedTracks: payload.reviews
      ? uniqBy([...prevState.missedTracks, ...payload.reviews], 'id')
      : [],
    totalMissedTracks: payload.total ? payload.total : 0,
  }),
  [GET_CANCELLED_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    cancelledTracks: payload.reviews ? payload.reviews : [],
    totalCancelledTracks: payload.total ? payload.total : 0,
  }),

  [GET_REVIEW_DETAILS.REQUEST]: prevState => ({
    ...prevState,
    loading: true,
  }),
  [GET_REVIEW_DETAILS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    reviewDetails: payload,
    loading: false,
  }),

  [GET_WORDS_BLACKLIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    wordsBlacklist: payload,
  }),
  [GET_CURATOR_STATS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    curatorStats: payload,
  }),
  [SKIP_REVIEW.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    totalAwaitingTracks: prevState.totalAwaitingTracks - 1,
    awaitingTracks: prevState.awaitingTracks.filter(
      ({ id }) => id !== Number(payload.review_id)
    ),
  }),
  [SEND_REVIEW.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    totalAwaitingTracks: prevState.totalAwaitingTracks - 1,
    awaitingTracks: prevState.awaitingTracks.filter(
      ({ id }) => id !== Number(payload.review.id)
    ),
  }),
  [GET_SELECTED_CURATOR_STATS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    selectedCuratorStats: payload,
  }),
}

export default createReducer(initialState, handlers)
